<template>
	<div class="container_t_padding clearfix">
		<div class="channel_banner"></div>
		
		<div class="video_box clearfix">
			<img src="../../assets/channel_video_bg.jpg" class="img" />
			<div class="video_module">
				<video id="myVideo" width="714" height="424" muted controls autoplay="autoplay" loop="loop">
				  <source src="../../assets/m.mp4" type="video/mp4">
				</video>
			</div>
		</div>
		
		<div class="case_box clearfix">
			<div class="center_box clearfix">
				<ul class="list">
					<li>
						<number-grow :value="32"></number-grow>
						<p class="txt">服务城市</p>
					</li>
					<li>
						<number-grow :value="5124"></number-grow>
						<p class="txt">服务用户</p>
					</li>
					<li>
						<number-grow :value="1245"></number-grow>
						<p class="txt">经典案例</p>
					</li>
					<li>
						<number-grow :value="981"></number-grow>
						<p class="txt">品牌联盟</p>
					</li>
				</ul>
			</div>
		</div>
		
		
		<div style="width: 100%; height: 390px; background: #f6f9fe;">
			<!-- <img src="../../assets/channel_img1.png" style="display: block; margin: 0 auto;" /> -->
			<div class="channel_business_box clearfix">
				<img src="../../assets/channel_title_img1.png" class="title_img" />
				<div class="item_wrap">
					<ul class="list">
						<li>
							<div class="img_box">
								<img src="../../assets/channel_b_img1.png" class="lt_img"/>
							</div>
							<div class="txt_box clearfix">
								<p class="title">企业投放获客成本高</p>
								<p class="txt">互联网流量红利结束，公域流量获客成本越来越高。SEM竞价高，转化率差。各类获客渠道都越来越难做</p>
							</div>
						</li>
						<li>
							<div class="img_box">
								<img src="../../assets/channel_b_img1.png" class="lt_img"/>
							</div>
							<div class="txt_box clearfix">
								<p class="title">企业投放获客成本高</p>
								<p class="txt">互联网流量红利结束，公域流量获客成本越来越高。SEM竞价高，转化率差。各类获客渠道都越来越难做</p>
							</div>
						</li>
						<li>
							<div class="img_box">
								<img src="../../assets/channel_b_img1.png" class="lt_img"/>
							</div>
							<div class="txt_box clearfix">
								<p class="title">企业投放获客成本高</p>
								<p class="txt">互联网流量红利结束，公域流量获客成本越来越高。SEM竞价高，转化率差。各类获客渠道都越来越难做</p>
							</div>
						</li>
						<li>
							<div class="img_box">
								<img src="../../assets/channel_b_img1.png" class="lt_img"/>
							</div>
							<div class="txt_box clearfix">
								<p class="title">企业投放获客成本高</p>
								<p class="txt">互联网流量红利结束，公域流量获客成本越来越高。SEM竞价高，转化率差。各类获客渠道都越来越难做</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		
		<div style="width: 1200px; margin: 0 auto;" class="solution_wrap clearfix">
			<!-- <img src="../../assets/channel_img2.png" /> -->
			<img src="../../assets/channel_title_img2.png" class="title_img" />
			<p class="title_txt">芒果科技致力于简化流程、数据驱动、营销赋能的“互联网+房地产”平台理念。提供以驱动营销+智慧管理为核心的企业一站式营销云解决方案，帮助企业打造业绩导向型营销闭环，助力业绩增长。</p>
			<div class="manage_wrap clearfix">
				<div class="lt_item clearfix">
					<p class="title">智慧营销管理</p>
					<i class="wire"></i>
					<p class="txt_p">跨平台采集和整合各渠道营销数据，一键管理及洞察分析数据，完成互联网+房地产的营销闭环，解决佣金发放痛点，帮助房企实现数据推动营销的一站式企业营销数据后台。</p>
				</div>
				<img src="../../assets/manage_img1.png" class="img" />
			</div>
		</div>
		
		<div style="width: 100%; height: 500px; background: #f6f9fe;">
			<!-- <img src="../../assets/channel_img3.png" style="display: block; margin: 0 auto;" /> -->
			<div class="platform_wrap clearfix">
				
			</div>
		</div>
		<div style="width: 1200px; margin: 0 auto;">
			<img src="../../assets/channel_img4.png" />
		</div>
		<div style="width: 100%; height: 500px; background: #f6f9fe;">
			<img src="../../assets/channel_img5.png" style="display: block; margin: 0 auto;" />
		</div>
		<div style="width: 1200px; margin: 0 auto;">
			<img src="../../assets/channel_img6.png" />
		</div>
		
	</div>
</template>

<script>
	import NumberGrow from '../../components/numberGrow/index.vue'
	export default{
		components:{
			NumberGrow
		},
		metaInfo: {
			title: '芒果科技渠道招商_全渠道获客_新房渠道平台_芒果科技蜗牛哥', // set a title
			meta: [{             // set meta
			  name: 'keyWords',
			  content: '芒果科技渠道招商,全渠道获客,大数据,获客矩阵,智慧营销管理,渠道整合平台,社交营销拓客,媒体属性'
			},
			{
			  name: 'description',
			  content: '芒果科技通过全渠道获客提供新房+saas营销平台,解决营销痛点,诚邀渠道招商'
			}]
		}
	}
</script>

<style lang="less">
	.channel_banner {
		min-width: 1200px; height: 500px; background: url(../../assets/channel_banner.jpg) top center no-repeat;
	}
	.video_box {
		width: 1200px; height: 707px; margin: 0 auto; position: relative; overflow: hidden;
		.img {
			width: 942px; margin: 50px auto 0; display: block;
		}
		.video_module {
			width: 714px; height: 424px; position: absolute; left: 243px; top: 181px;
			#myVideo {
				width: 100%; height: 100%; object-fit: fill;
			}
		}
	}
	.case_box {
		width: 100%; height: 160px; background: #0591fb;
		.center_box {
			width: 1200px; height: 160px; margin: 0 auto;
			.list {
				display: flex; list-style: none; padding: 0; margin: 0;
				li {
					flex: 1; height: 160px; overflow: hidden; text-align: center; padding: 39px 0 0 0; box-sizing: border-box;
					.number-grow {
						font-size: 40px; color:#fff; font-weight: bold; letter-spacing: 2px; text-align: center; display: block; line-height: 1;
					}
					.txt {
						font-size: 20px; color:#fff; line-height: 1; margin-top: 12px;
					}
				}
			}
		}
	}
	
	// 业务通点
	.channel_business_box {
		width: 1200px; margin: 0 auto; height: 390px; overflow: hidden;
		.title_img {
			margin: 50px auto 15px; display: block;
		}
		.item_wrap {
			 padding: 0 55px;
			 .list {
				 padding: 0; margin: 0; display: flex; justify-content: space-between;flex-wrap: wrap;
				 li {
					 overflow: hidden; display: flex;
					 .img_box {
						display: flex; align-items: center;
					 }
					 .txt_box {
						 width: 380px; margin-left: 31px;
						 .title {
							 font-size: 20px; color: #333; line-height: 1; margin-bottom: 12px;
						 }
						 .txt {
							 font-size: 14px; line-height: 22px;
						 }
					 }
					 
					 &:nth-child(3) {
						 margin-top: 58px;
					 }
					 &:nth-child(4) {
					 	margin-top: 58px;
					 }
				 }
			 }
		}
	}
	
	// 产品解决方案
	.solution_wrap {
		overflow: hidden; padding-bottom: 122px;
		.title_img {
			display: block; margin: 60px auto 24px;
		}
		.title_txt {
			font-size: 16px; color: #333; line-height: 28px; width: 850px; margin: 0 auto; text-align: center;
		}
		.manage_wrap {
			 margin-top: 87px;
			.lt_item {
				float: left; overflow: hidden; width: 545px; margin-left: 42px; padding-top: 18px;
				.title { font-size: 26px; color: #333; line-height: 1;}
				.wire { width: 54px; height: 4px; display: block; background-image: linear-gradient(to right, #0590fb , #097ef7); margin-top: 20px;}
				.txt_p {
					font-size: 16px; color: #333; line-height: 28px; margin-top: 14px;
				}
			}
			.img {
				float: right; margin-right: 118px;
			}
		}
	}
</style>
